export const ShopCategory = {
    'shop_category': 'Shop Category',
    'name': 'Name',
    'description': 'Description',
    'status': 'Status',
    'table_name': 'SHOP CATEGORY',
    'table_status': 'STATUS',
    'table_description': 'DESCRIPTION',
    'error_name': 'Shop Category Name is required',
    'error_status': 'Status is required',
    'error_description': 'Description is required',
}
